import { IConsentManager } from 'confor-consentement-application';
let manager: IConsentManager;

export default function getConsentManager(getToken: () => Promise<string>) {
  if (!manager) {
    manager = new ConsentManager(
      {
        context: 'Sales',
        source: 'ClientSpace',
        type: 'SelfServe',
        getToken,
      },

    );
  }
  return manager;
}
